import { Dependencies } from "../interfaces/dependencies-types";

export class ModalController implements Dependencies {
    private refModal: HTMLElement;
    private popupEventCallback: Function;

    public async initialize () {
        this.appendStyle();

        this.refModal = this.createThePopup();
        this.registerCloseHandler();


        let isiOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false);

        if (isiOS === true) {
            document.querySelector('body').style.cursor = 'pointer';
        }
    }

    private appendStyle() {
        const timeoutCSSElement = document.createElement('style');
        timeoutCSSElement.type = 'text/css';
        timeoutCSSElement.innerHTML =
            '.timeout-modal{--primary_color:#e00087;--secondary_color:#15c;display:none;position:fixed;z-index:99999;left:0;top:0;width:100%;height:100%;background-color:#000;background-color:rgba(0,0,0,.4)}.timeout-modal .timeout-modal-content{border-radius:5px;font-family:tahoma,arial;background-color:#fefefe;margin:15% auto;padding:20px;border:1px solid #888;max-width:350px}.timeout-modal .timeout-modal-content .timeout-modal-header{display:flex;flex-direction:column;margin-bottom:20px}.timeout-modal .timeout-modal-content .timeout-modal-title{font-weight:700;color:#293b51;text-align:center;padding:0 10px!important;font-size:20px}.timeout-modal .timeout-modal-content .timeout-close{color:#63788f;float:right;font-size:28px;font-weight:500;margin-top:-9px}.timeout-modal .timeout-modal-content .timeout-close:focus,.timeout-modal .timeout-modal-content .timeout-close:hover{text-decoration:none;cursor:pointer}.timeout-modal .timeout-modal-content .timeout-modal-body{padding:0 10px}.timeout-modal .timeout-modal-content .timeout-modal-body p{padding:0!important;margin:0!important;color: #394e66;text-align:center}.timeout-modal .timeout-modal-content .timeout-modal-body a{color:var(--secondary_color);text-decoration:none}.timeout-modal .timeout-modal-content .timeout-modal-body a:hover{text-decoration:none}.timeout-modal .timeout-modal-content .timeout-modal-footer{display:flex;justify-content:center;padding-top:20px;text-align:right}.timeout-modal .timeout-modal-content .timeout-modal-footer .agree{border:none;padding:10px 15px;border-radius:5px;min-width:200px;background-color:var(--primary_color);color:#fff;font-weight:600}';
        document.head.appendChild(timeoutCSSElement);
    }

    private createThePopup() {
        const myModal = document.createElement('div');
        myModal.id = 'timeout-myModal';
        myModal.className = 'timeout-modal';
        document.body.appendChild(myModal);
        return myModal;
    }

    public openModal(title:string = 'Whoops!', message: string, buttonTitle: string = '', callback?: Function) {
        
        this.applySetColors();

        this.refModal.innerHTML = `<div class="timeout-modal-content">
        <div class="timeout-modal-header">
            <div>
                <span class="timeout-close">&times;</span>
            </div>
            <div class="timeout-modal-title">${title}</div>
        </div>
        <div class="timeout-modal-body">
            <p>${message}</p>
        </div>
        <div class="timeout-modal-footer">
            ${(buttonTitle != '' ? ('<button class="agree">' + buttonTitle + '</button>') :'')}
        </div>
    </div>`;
        this.refModal.style.display = 'block';
        this.popupEventCallback = callback;
    }

    private registerCloseHandler() {
        window.addEventListener('click', (event: Event) => {
            const clickedElement: HTMLElement = <HTMLElement>event.target;
            
            if (event.target == this.refModal) {
                this.refModal.style.display = 'none';
                if (this.popupEventCallback) {
                    this.popupEventCallback('close');
                }
                // window.location.reload();
            }

            if (clickedElement.classList.contains('timeout-close')) {
                this.refModal.style.display = 'none';
                if (this.popupEventCallback) {
                this.popupEventCallback('close');
                }
                // window.location.reload();
            }

            if (clickedElement.classList.contains('agree')) {
                this.refModal.style.display = 'none';
                if (this.popupEventCallback) {
                this.popupEventCallback('agree');
                }
            }
        });
    }

    private applySetColors() {
        if(this.refModal && window.obfOptions?.theme){
            if(window.obfOptions.theme['primary-color']) {
                this.refModal.style.setProperty('--primary_color', window.obfOptions.theme['primary-color']);
            }
            
            if(window.obfOptions.theme['secondary-color']) {
                this.refModal.style.setProperty('--secondary_color', window.obfOptions.theme['secondary-color']);
            }
        }
    }
}
